<template>
  <section>
    <p class="pricing__type">Total</p>
    <div class="pricing__total-group">
      <div class="pricing__line">
        <p class="pricing__label">subtotal</p>
        <p class="pricing__value">
          <span>{{ currencySymbol }}</span>
          <span>{{ subtotalStr }}</span>
        </p>
      </div>
      <div class="pricing__line">
        <p class="pricing__label">discount</p>
        <p class="pricing__value">
          <template v-if="showPromotionSavings">
            <span class="pricing__value--bf-discount">
              {{
                isCyberMondayActive
                  ? 'Cyber Monday savings applied!'
                  : 'Black Friday savings applied!'
              }}
            </span>
          </template>
          <span>{{ currencySymbol }}</span>
          <span>{{ discountStr }}</span>
        </p>
      </div>
      <div class="pricing__line">
        <p class="pricing__label">tax</p>
        <p class="pricing__value">
          <span>{{ taxesLabel }}</span>
        </p>
      </div>
      <div class="pricing__total">
        <p class="pricing__label pricing__label--total">
          {{ totalLabel }}
        </p>
        <p class="pricing__value pricing__value--total">
          <span>{{ currencySymbol }}</span>
          <span>{{ totalStr }} {{ currencyCode }}</span>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { routesRules } from '@/helpers/mixins'

export default {
  name: 'PricingListPriceDetails',
  mixins: [routesRules],
  computed: {
    ...mapGetters({
      currencySymbol: 'priceDetails/getCurrencySymbol',
      currencyCode: 'priceDetails/getCurrencyCode',
      subtotalStr: 'priceDetails/getSubtotalStr',
      discountStr: 'priceDetails/getDiscountStr',
      taxes: 'priceDetails/getTaxes',
      taxesStr: 'priceDetails/getTaxesStr',
      totalStr: 'priceDetails/getTotalStr',
      showPromotionSavings: 'priceDetails/getShowPromotionSavings',
      isCyberMondayActive: 'featureFlags/isCyberMondayActive',
    }),
    taxesLabel() {
      return this.taxes > 0 ? `${this.currencySymbol}${this.taxesStr}` : 'Not Included'
    },
    totalLabel() {
      if (this.isConfirmationPage) {
        return 'Total due today'
      }
      return this.taxes > 0 ? 'Total due today' : 'Total before tax'
    },
  },
}
</script>

<style lang="scss">
.pricing {
  &__type {
    font-family: var(--font-regular);
    color: var(--white);
    font-size: rem(20px);
    line-height: 26px;
    text-align: left;
    font-weight: 700;
    margin-bottom: 10px;
  }
  &__line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0 0 15px 0;
    &:last-child {
      margin: 0;
    }
  }
  &__label {
    font-family: var(--font-regular);
    text-transform: capitalize;
    font-size: rem(16);
    margin: 0;
    &--total {
      color: var(--white);
      text-transform: none;
      font-size: rem(18);
    }
  }
  &__value {
    font-family: var(--font-regular);
    font-size: rem(16);
    margin: 0;
    &--total {
      color: var(--white);
      text-transform: none;
      font-size: rem(16);
    }
    &--bf-discount {
      color: var(--purple-pale);
      font-size: rem(12px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(14px); /* 116.667% */
      margin-right: 10px;
    }
  }
  &__total {
    font-weight: 500;
    font-size: rem(18px);
    line-height: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-top: 1px solid #444444;
    padding-top: 5px;
  }
  &__total-group {
    background: linear-gradient(
      111.02deg,
      rgba(18, 18, 18, 0.7) 3.86%,
      rgba(18, 18, 18, 0) 107.96%
    );
    border-radius: 10px;
    padding: 15px;
    color: var(--white);
  }
}
</style>
